export default "__VITE_ASSET__o17NuyWU__"